import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { ProjectsPage } from './pages/ProjectsPage';
import { RefundPolicyPage } from './pages/RefundPolicyPage';
import { TermsOfUsePage } from './pages/TermsOfUsePage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import ReactGA from "react-ga4";
ReactGA.initialize("G-Y8ENESDF3M");
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/projects" element={<ProjectsPage data-id="element-5" />} data-id="element-4" />
        <Route path="/refund-policy" element={<RefundPolicyPage data-id="element-7" />} data-id="element-6" />
        <Route path="/terms" element={<TermsOfUsePage data-id="element-9" />} data-id="element-8" />
        <Route path="/privacy" element={<PrivacyPolicyPage data-id="element-11" />} data-id="element-10" />
      </Routes>
    </BrowserRouter>;
}